import * as yup from 'yup';
import { SolarFarmSchema } from '../../schemas/SolarFarmSchema';
import { OrgSchema } from '../../schemas/OrgSchema';

export const UpdateShowDeltaTResponseSchema = yup.object({
  exit_status: yup.number().defined(),
  show_delta_t: yup.boolean().defined(),
});

export type UpdateShowDeltaTResponse = yup.InferType<
  typeof UpdateShowDeltaTResponseSchema
>;

export const UpdateOrderResponseSchema = yup.object({
  id: yup.number().defined(),
  uuid: yup.string().defined(),
  org_id: yup.number().defined(),
  creator_id: yup.number().defined(),
  updator_id: yup.number().defined(),
  priority: yup.number().defined(),
  order_type: yup.string().nullable(),
  status: yup.number().nullable(),
  substatus: yup.number().nullable(),
  submitted_tsecs: yup.number().nullable(),
  delivered_tsecs: yup.number().nullable(),
  created_tsecs: yup.number().nullable(),
  updated_tsecs: yup.number().nullable(),
  contract_type: yup.string().nullable(),
  special_instructions: yup.string().nullable(),
  data_received_tsecs: yup.number().nullable(),
  solar_farm_uuid: yup.string().nullable(),
  requested_delivery_date: yup.number().nullable(),
  requested_flight_date: yup.number().nullable(),
  site_contact_uuid: yup.string().nullable(),
  pilot_contact_uuid: yup.string().nullable(),
  estimated_delivery_date: yup.number().nullable(),
  estimated_flight_date: yup.number().nullable(),
  pm_user_id: yup.number().nullable(),
  data_collection_manager_id: yup.number().nullable(),
  flight_start_date: yup.number().nullable(),
  flight_end_date: yup.number().nullable(),
  id_report_provider: yup.number().nullable(),
  turnkey_services: yup.boolean().nullable(),
  solar_farm: SolarFarmSchema.nullable(),
  image_skip_rate: yup.number().nullable(),
  claimed_by_user_id: yup.number().nullable(),
  channel: yup.string().nullable(),
  comments_to_channel: yup.string().nullable(),
  comments_from_channel: yup.string().nullable(),
  internal_comments: yup.string().nullable(),
  source_order_uuid: yup.string().nullable(),
  data_collection_status: yup.number().nullable(),
  accounting_invoice_number: yup.string().nullable(),
  mailing_list: yup.string().nullable(),
  sales_project_id: yup.number().nullable(),
  email_updates_enabled: yup.boolean().nullable(),
  processing_hold: yup.boolean().defined(),
  data_collection_org_id: yup.number().nullable(),
  client_org_id: yup.number().nullable(),
  channel_orgs: yup.array(OrgSchema.defined()).nullable(),
});

export type UpdateOrderResponse = yup.InferType<
  typeof UpdateOrderResponseSchema
>;

export interface OrderUpdate {
  org_id: number;
  order_type: string;
  solar_farm_uuid: string;
  uuid: string;
  priority: number;
  delivered_tsecs?: number | null;
  contract_type?: string | null;
  requested_delivery_date?: number | null;
  turnkey_services?: boolean | null;
  requested_flight_date?: number | null;
  site_contact_uuid?: string | null;
  pilot_contact_uuid?: string | null;
  estimated_delivery_date?: number | null;
  estimated_flight_date?: number | null;
  data_collection_status?: number | null;
  email_updates_enabled?: boolean | null;
  flight_start_date?: number | null;
  flight_end_date?: number | null;
  updator_id?: number | null;
  channel_orgs?: Array<{ id: number }> | null;
  client_orgs?: Array<{ id: number }> | null;
  client_org_id?: number | null;
  substatus?: number | null;
  claimed_by_user_id?: number | null;
  comments_to_channel?: string | null;
  comments_from_channel?: string | null;
  special_instructions?: string | null;
  internal_comments?: string | null;
  processing_hold?: boolean | null;
  data_received_tsecs?: number | null;
  source_order_uuid?: string | null;
  data_collection_org_id?: number | null;
  accounting_invoice_number?: string | null;
  pm_user_id?: number | null;
  mailing_list?: string | string[] | null;
  sales_project_id?: number | null;
  data_collection_manager_id?: number | null;
  id_report_provider?: number | null;
  image_skip_rate?: number | null;
}
